import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { ReactNode } from "react";

type VisuallyHiddenAltProps = {
  children: ReactNode;
};

export default function VisuallyHiddenAlt({ children }: VisuallyHiddenAltProps) {
  return <VisuallyHidden.Root>{children}</VisuallyHidden.Root>;
}
